// Время в формате ЧЧ:ММ (24 часа).
const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const isValidTime = (value?: string | null): value is string =>
  !!value && TIME_PATTERN.test(value);

export const timeToMinutes = (value: string) => {
  const [hours, minutes] = value.split(':').map(Number);

  return hours * 60 + minutes;
};

// Сколько первых цифр занимают часы: одна, если двухзначных часов из них
// не получается («9» → 9:.., «25» → 2:5), иначе две.
const getHoursLength = (digits: string) =>
  Number(digits[0]) > 2 || Number(digits.slice(0, 2)) > 23 ? 1 : 2;

// Оставляет в вводе только цифры и сама ставит двоеточие после часов:
// «1030» → «10:30», «930» → «9:30». Если двоеточие введено вручную («9:30»),
// часы и минуты берутся по нему.
export const formatTimeInput = (rawValue: string) => {
  if (rawValue.includes(':')) {
    const [hours = '', minutes = ''] = rawValue.split(':');

    return `${hours.replace(/\D/g, '').slice(0, 2)}:${minutes
      .replace(/\D/g, '')
      .slice(0, 2)}`;
  }

  const digits = rawValue.replace(/\D/g, '').slice(0, 4);

  if (!digits) {
    return digits;
  }

  const hoursLength = getHoursLength(digits);
  const hours = digits.slice(0, hoursLength);
  const minutes = digits.slice(hoursLength, hoursLength + 2);

  return minutes ? `${hours}:${minutes}` : hours;
};

// Дополняет неполный ввод при потере фокуса: «9» → «09:00», «9:30» → «09:30».
// Три цифры читаются как Ч:ММ: «13:0» (набрано «130») → «01:30».
export const normalizeTimeInput = (value: string) => {
  if (!value) {
    return value;
  }

  const [hours = '', minutes = ''] = value.split(':');

  if (hours.length === 2 && minutes.length === 1) {
    const reinterpretedValue = `0${hours[0]}:${hours[1]}${minutes}`;

    return isValidTime(reinterpretedValue) ? reinterpretedValue : value;
  }

  if (!hours || hours.length > 2 || minutes.length === 1) {
    return value;
  }

  return `${hours.padStart(2, '0')}:${minutes.padEnd(2, '0')}`;
};
